// 微信 JSSDK 接入：https://developers.weixin.qq.com/doc/subscription/guide/h5/jssdk.html
import { isServer } from "@/lib/constant";
import { Level, reportCustomMetric, reportError } from "@/lib/owl";

// 4.5KB 126ms
const JS_SDK_SCRIPT_URL = "https://res.wx.qq.com/open/js/jweixin-1.6.0.js";

// 上报 wx JSSDK 初始化成功率
type LoadJSSDKErrMsg = "success" | "scriptLoadError";

function reportLoadJSSDKSuccessRate(
  isSuccess: boolean,
  errMsg: LoadJSSDKErrMsg = "success"
) {
  reportCustomMetric({
    key: "loadJSSDK",
    value: isSuccess ? 1 : 0,
    tags: {
      errMsg,
    },
  });
}

/**
 * 加载 JSSDK 脚本
 * @returns Promise<void> 是否加载成功
 */
function loadJSSDK() {
  if (isServer) return;
  if (window?.FXBridge?.loadJSSDKPromise) return window?.FXBridge?.loadJSSDKPromise;
  (window.FXBridge = window.FXBridge || {}).loadJSSDKPromise = new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = JS_SDK_SCRIPT_URL;
    script.onload = () => {
      resolve();
      reportLoadJSSDKSuccessRate(true);
    };
    script.onerror = (err) => {
      resolve();
      reportError({
        name: "[loadJSSDK] scriptLoadError",
        msg: err,
        category: "bridgeError",
        level: Level.WARN,
      });
      reportLoadJSSDKSuccessRate(false, "scriptLoadError");
    };
    document.head.appendChild(script);
  });
  return window.FXBridge.loadJSSDKPromise;
}

/**
 * 初始化 JSSDK 桥
 */
export function initWXBridge() {
  if (isServer) return;
  if (!window?.wx?.miniProgram) loadJSSDK();
}
